module.exports = __webpack_public_path__ + "toBride1-jp-w-n.ed951970.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-jp-w-n.jpg
// module id = Jo/a
// module chunks = 0